import { useEffect, useState } from 'react';

import { getBusinessCommitmentPolicy } from '../../services/businessNotificationService';
import { describeReceivingWindows, receivingDayNote } from '../../utils/dispatchReasons';

// Shown beside "No one can receive the rider back inside the hours set in
// Delivery Setup": the actual receiving days and hours, and whether today is one
// of them. Without it the owner had to guess which setting was refusing.
export default function ReceivingHoursHint({ className = '' }) {
  const [windows, setWindows] = useState(null);
  useEffect(() => {
    let cancelled = false;
    getBusinessCommitmentPolicy()
      .then((response) => { if (!cancelled) setWindows(response?.data?.policy?.settlementWindows || []); })
      .catch(() => { if (!cancelled) setWindows([]); });
    return () => { cancelled = true; };
  }, []);
  if (!windows || !windows.length) return null;
  const note = receivingDayNote(windows);
  return (
    <p className={`text-sm ${className}`} data-testid="receiving-hours">
      Riders can be received back: <strong>{describeReceivingWindows(windows)}</strong>.
      {note ? <> <strong>{note}</strong></> : ' A trip must end inside these hours, including the ride back to the store.'}
    </p>
  );
}
